import React, { useEffect, useRef, useState } from 'react'
import CopyText from 'components/atoms/CopyText';
import PageHeader from 'components/molecules/PageHeader';
import TableDataSpan from 'components/organisms/app-table/TableDataSpan';
import { useParams } from 'react-router-dom'
import AppTable from 'components/organisms/app-table';
import PageTitle from 'components/atoms/PageTitle';
import ViewTransaction from '../ModalComponents/ViewTransactionModal';
import ColorTag from 'components/atoms/ColorTag';
import ProgressBar from 'components/molecules/ProgressBar';
import RadioInput from 'components/atoms/RadioInputGroup';
import useWindowSize from '../../../components/atoms/WindowWidth.jsx';
import { BASE_URL, getRequest, loggedUser_baseURL } from 'services/http';
import moment from 'moment';
import Alert from 'components/atoms/Alert';
import { connect, useSelector } from 'react-redux';
import Button from 'components/atoms/Button';
import refreshIcon from '../../../assets/svg/refresh.svg';
import editIcon from '../../../assets/svg/edit-white.svg';
import SetCommission from '../ModalComponents/SetCommission';
import useDebounce from 'components/molecules/useDebounce';
import { channel } from 'diagnostics_channel';

const BusinessDetails = (props) => {
    const [loading, setLoading] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalState, setModalState] = useState(false);
    const [transactions, setTransactions] = useState<any>([]);
    const [totalTransactions, setTotalTransactions] = useState(Number);
    const [transactionDetails, setTransactionDetails] = useState<any>([]);
    const [businessDetails, setBusinessDetails] = useState<any>([]);
    const [commissionData, setCommisionData] = useState<any>([]);
    const [searchInput, setSearchInput] = useState('')
    const [selectedCommission, setSelectedCommission] = useState('local');
    const [pageNum, setPageNum] = useState(null);
    const [recordsPerPage] = useState(8);
    const [selectedPaymentChannel, setSelectPaymentChannel] = useState('');
    const [selectedTransactionStatus, setSelectedTransactionStatus] = useState('');
    const [selectedSearchKey, setSelectedSearchKey] = useState('');
    const [query, setQuery] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [dateValid, setDateValid] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const businessID = useParams();

    const debouncedQuery = useDebounce(query, 800);

    useEffect(() => {
        const currentDate = moment().endOf('day'); // Adjust to 09:00:00
        const oneMonthAgo = moment().subtract(1, 'months').startOf('day'); // Adjust to 09:00:00

        const start = oneMonthAgo.format('YYYY-MM-DD HH:mm:ss');
        const end = currentDate.format('YYYY-MM-DD HH:mm:ss');

        setStartDate(start);
        setEndDate(end);
    }, [refresh]);

    const getCurrentPage = (pageNumber) => {
        setPageNum(pageNumber);
    }

    const setFeeRuleData = [
        { label: "Local", value: "local" },
        { label: "International", value: "international" }
    ]

    const country = businessDetails?.businessCountry;

    const countries = useSelector((state: any) => state.app.countries);
    const businessCountry = countries?.find((c) => c.name.toLowerCase() === country?.toLowerCase());

    const paymentChannelList = businessCountry?.name === "NIGERIA"
        ? businessCountry?.defaultPaymentOptions.filter(channel => channel.name !== 'MOMO').map((op: any) => ({
            label: op?.code,
            value: op?.code
        })) || []

        : businessCountry?.defaultPaymentOptions.map((op: any) => ({
            label: op?.code,
            value: op?.code
        })) || []

    const FilterData = [
        { titleText: 'Payment Channel', filters: paymentChannelList, selected: selectedPaymentChannel, setSelected: setSelectPaymentChannel },
        // { titleText: 'Transaction Status', filters: transactionStatusList, selected: selectedTransactionStatus, setSelected: setSelectedTransactionStatus },
    ]

    const searchParams = ["paymentRef", "customerName"];

    const viewTransaction = (id) => {
        setShowModal(prevState => !prevState)
        const transactionFilter = transactions.filter(item => item.paymentReference === id)
        const transactionItem = transactionFilter[0]
        setTransactionDetails(transactionItem)
    }

    const getBusinessDetails = () => {
        const filteredData = props.businessData.filter(item => item.businessId === businessID.id);
        setBusinessDetails(filteredData[0]);
    }

    const urlParam = `?size=${recordsPerPage}&page=${pageNum === null ? 0 : pageNum}&startDate=${startDate}&endDate=${endDate}&transactionStatus=COMPLETED`;

    const default_url = `${BASE_URL + loggedUser_baseURL + `${businessID.id}/transactions` + urlParam}`;

    const main_url = debouncedQuery !== '' && dateValid
        ? `${default_url}&${selectedSearchKey}=${debouncedQuery}`

        : selectedPaymentChannel !== '' && dateValid
            ? `${default_url}&paymentChannel=${selectedPaymentChannel}`

            : selectedTransactionStatus !== '' && dateValid
                ? `${default_url}&transactionStatus=${selectedTransactionStatus}`

                : selectedPaymentChannel !== '' && selectedTransactionStatus !== '' && dateValid
                    ? `${default_url}&paymentChannel=${selectedPaymentChannel}&transactionStatus=${selectedTransactionStatus}`

                    : debouncedQuery !== '' && selectedPaymentChannel !== '' && selectedTransactionStatus !== '' && dateValid
                        ? `${default_url}&${selectedSearchKey}=${debouncedQuery}&paymentChannel=${selectedPaymentChannel}&transactionStatus=${selectedTransactionStatus}`

                        : debouncedQuery === ''
                            ? `${default_url}`

                            : null;

    const getBusinessTransactions = async () => {
        setLoading(true);
        const res = await getRequest(main_url, {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        });

        if (res?.data.status === 'SUCCESS') {
            // Alert('success', res?.data.message);
            setTransactions(res?.data.data);
            setTotalTransactions(res?.data.totalElements);

            setTimeout(() => setLoading(false), 1500);
        } else {
            setLoading(false);
        }
    }

    const getBusinessCommissions = async () => {
        // setLoading(true);
        const res = await getRequest(`${BASE_URL + loggedUser_baseURL + 'commissions/' + businessID.id}`, {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${props.bearerToken}`
        });

        if (res?.data.responseCode === '00') {
            setLoading(false);
            // Alert('success', res?.data.message);
            setCommisionData(res?.data.data.channels);
        } else {
            setLoading(false);
            Alert('info', res?.data.message);
        }
    }

    useEffect(() => {
        setLoading(true);
        getBusinessDetails();
        getBusinessCommissions();

        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, [props.businessDetails, refresh]);

    useEffect(() => {
        if (startDate !== '' && endDate !== '' && dateValid) getBusinessTransactions();
    }, [startDate, endDate, refresh, pageNum]);

    useEffect(() => {
        if (debouncedQuery !== ''
            || debouncedQuery === ''
            || selectedPaymentChannel !== ''
            || selectedTransactionStatus !== ''
        ) {
            setTimeout(() => getBusinessTransactions(), 800);
        }
    }, [debouncedQuery, selectedPaymentChannel, selectedTransactionStatus]);

    const columns = [
        {
            label: 'Date',
            render: (data) => <TableDataSpan
                handleMouseEnter={() => { }}
                onClick={() => viewTransaction(data.paymentReference)}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
                text={moment(data.date).format('MMM DD, YYYY - LTS')}
            />
        },
        {
            label: 'Amount',
            render: (data) => <TableDataSpan
                handleMouseEnter={() => { }}
                onClick={() => viewTransaction(data.paymentReference)}
                additionalClass="cursor-default"
                text={data.currency + " " + (Intl.NumberFormat().format(data.amount))}
            />
        },
        {
            label: 'Commission Amount',
            render: (data) => <TableDataSpan
                handleMouseEnter={() => { }}
                onClick={() => viewTransaction(data.paymentReference)}
                text={data.currency + " " + (Intl.NumberFormat().format(data.commissionAmount === null ? 0 : data.commissionAmount))}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
            />
        },
        {
            label: 'Payment Channel',
            render: (data) => <TableDataSpan
                onClick={() => viewTransaction(data.paymentReference)}
                handleMouseEnter={() => { }}
                text={data.paymentChannel}
                additionalClass='text-opacity-70 text-xs cursor-pointer'
            />
        }
    ]

    const filteredChannels = commissionData.map(channelItem => {
        return {
            channel: channelItem.channel,
            transactions: transactions.filter(item => item.paymentChannel === channelItem.channel)
        };
    });

    const ChannelTotal = filteredChannels.reduce((total, channel) => total + channel.transactions.length, 0);

    const colors = ['!bg-Accent_blue', '!bg-Warning', '!bg-Success', '!bg-PrimaryActive', '!bg-purple-400']; // Define your color classes here

    const progressBar = filteredChannels.map((channelItem, i) => {
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        return (
            <div key={i} className='flex items-center justify-between gap-3'>
                <p className='text-sm font-normal leading-6 text-DarkBg3'>{channelItem.channel}</p>

                <ProgressBar
                    fullCap={ChannelTotal}
                    currentCap={channelItem?.transactions?.length}
                    height={5}
                    barStyle='!bg-BackDrop_d_xs'
                    loaderStyle={randomColor}
                    wrapperStyle='w-3/5'
                    percentageStyle='bottom-1 !text-xs'
                />
            </div>
        )
    })

    return (
        <div className='absolute top-0 left-0 flex flex-col w-full h-full tablet:relative tablet:gap-10'>
            <div className='justify-between hidden gap-5 tablet:flex'>
                <Button
                    btnType='button'
                    btnText='Refresh'
                    btnStyle='bg-SecondaryAccent5 text-DarkBg3 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                    btnImg={refreshIcon}
                    btnImgStyle={`w-4 h-4 ${loading && 'animate-fullRoll'}`}
                    onClick={() => setRefresh(prevState => !prevState)}
                />
                <Button
                    btnType='button'
                    btnText='Set Fees'
                    btnStyle='bg-DarkBg3 text-SecondaryAccent5 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                    btnImg={editIcon}
                    btnImgStyle={`w-4 h-4`}
                    onClick={() => setModalState(prevState => !prevState)}
                />
            </div>

            <div className='flex-col hidden gap-5 tablet:flex'>
                <span className='flex flex-col justify-start gap-0 tablet:gap-5 mobile:justify-between tablet:flex-row tablet:items-center'>
                    <PageTitle
                        pageTitle={`${businessDetails?.businessName}`}
                        pageTitleStyle='!mb-0 !mt-0 !truncate'
                    />
                    <span className='h-fit'>
                        <ColorTag
                            styleColor={`bg-Green_Accent4 border-Green_Accent rounded-md px-3 py-1 flex gap-1 items-center`}
                            text='Active'
                            textColor={`text-Success font-semibold text-sm leading-5`}
                            BgColor={`bg-Success`}
                        />
                    </span>
                </span>
                <span className='flex flex-col gap-1 font-normal leading-5'>
                    <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business ID</p>
                    <p className='text-base mobile:text-sm'>{`${businessDetails?.businessId}`}</p>
                </span>
                <span className='flex flex-col gap-1 font-normal leading-5'>
                    <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business Email</p>
                    <p className='text-base mobile:text-sm'>{`${businessDetails?.businessEmail === null ? "NA" : businessDetails?.businessEmail}`}</p>
                </span>
                <span className='flex flex-col gap-1 font-normal leading-5'>
                    <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Country</p>
                    <p className='text-base mobile:text-sm'>{`${country}`}</p>
                </span>
            </div>

            <div className='flex flex-row tablet:flex-col tablet:gap-16 min-h-[93vh] h-full'>
                <div className='flex flex-col w-full gap-5 px-8 py-10 tablet:p-0'>
                    <div className='justify-end hidden gap-5 desktop:flex'>
                        <Button
                            btnType='button'
                            btnText='Refresh'
                            btnStyle='bg-SecondaryAccent5 text-DarkBg3 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                            btnImg={refreshIcon}
                            btnImgStyle={`w-4 h-4 ${loading && 'animate-fullRoll'}`}
                            onClick={() => setRefresh(prevState => !prevState)}
                        />
                        <Button
                            btnType='button'
                            btnText='Set Fees'
                            btnStyle='bg-DarkBg3 text-SecondaryAccent5 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                            btnImg={editIcon}
                            btnImgStyle={`w-4 h-4`}
                            onClick={() => setModalState(prevState => !prevState)}
                        />
                    </div>
                    <div className='flex flex-col w-full gap-20 mobile:gap-10'>
                        <div className='flex w-full gap-5 mobile:flex-col'>
                            <div className='w-full bg-Danger3 p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                <span className='font-normal text-[15px] leading-5'>
                                    Amount Transacted
                                </span>
                                <span className='font-semibold text-[26px] leading-[31.2px]'>
                                    {`${businessDetails?.businessCurrency === null || businessDetails?.businessCurrency === undefined ? "" : businessDetails?.businessCurrency} ${businessDetails?.totalAmountTransacted === null || businessDetails?.totalAmountTransacted === undefined ? 0 : Intl.NumberFormat().format(businessDetails?.totalAmountTransacted)}`}
                                </span>
                            </div>

                            <div className='w-full bg-Success p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                <span className='font-normal text-[15px] leading-5'>
                                    Total Commissions
                                </span>
                                <span className='font-semibold text-[26px] leading-[31.2px]'>
                                    {`${businessDetails?.businessCurrency === null || businessDetails?.businessCurrency === undefined ? "" : businessDetails?.businessCurrency} ${businessDetails?.totalCommissions === null || businessDetails?.totalCommissions === undefined ? 0 : Intl.NumberFormat().format(businessDetails?.totalCommissions)}`}
                                </span>
                            </div>

                            <div className='w-full bg-SecondaryAccent p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                <span className='font-normal text-[15px] leading-5'>
                                    Transaction Count
                                </span>
                                <span className='font-semibold text-[26px] leading-[31.2px]'>
                                    {`${businessDetails?.totalTransactionCount === null || businessDetails?.totalTransactionCount === undefined ? 0 : businessDetails?.totalTransactionCount}`}
                                </span>
                            </div>
                        </div>
                        <div className='flex flex-col w-full gap-10 overflow-y-hidden'>
                            <PageHeader
                                pageTitle='Transactions'
                                filterData={FilterData}
                                dateFilter={true}
                                searchInput={query}
                                setSearchInput={setQuery}
                                searchKey={selectedSearchKey}
                                setSearchKey={setSelectedSearchKey}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                                setDateValid={setDateValid}
                                searchOpts={searchParams}
                                wrapperStyle='!gap-1'
                                loading={loading}
                            />
                            <AppTable
                                columns={columns}
                                data={transactions}
                                itemsPerPage={recordsPerPage}
                                addedStyle={`h-[40vh] ${loading && 'h-[30vh]'}`}
                                loading={loading}
                                errorState={errorState}
                                dataLength={totalTransactions}
                                getCurrentPage={getCurrentPage}
                            />
                        </div>
                    </div>
                </div>



                <div className='py-10 px-8 mobile:px-0 w-[30%] h-full tablet:w-full bg-white mobile:bg-AppBg grid desktop:grid-cols-1 grid-cols-2 mobile:grid-cols-1 gap-20 tablet:gap-8'>
                    <div className='flex flex-col gap-5 tablet:hidden'>
                        <span className='flex flex-col justify-start gap-0 tablet:gap-5 mobile:justify-between tablet:flex-row tablet:items-center'>
                            <PageTitle
                                pageTitle={`${businessDetails?.businessName === null || businessDetails?.businessName === undefined ? 'Not Available' : businessDetails?.businessName}`}
                                pageTitleStyle='!mb-0 !mt-0 !truncate'
                            />
                            <span className='h-fit'>
                                <ColorTag
                                    styleColor={`bg-Green_Accent4 border-Green_Accent rounded-md px-3 py-1 flex gap-1 items-center`}
                                    text='Active'
                                    textColor={`text-Success font-semibold text-sm leading-5`}
                                    BgColor={`bg-Success`}
                                />
                            </span>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business ID</p>
                            <p className='text-base mobile:text-sm'>{`${businessDetails?.businessId === null || businessDetails?.businessId === undefined ? 'Not Available' : businessDetails?.businessId}`}</p>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business Email</p>
                            <p className='text-base mobile:text-sm'>{`${businessDetails?.businessEmail === null || businessDetails?.businessEmail === undefined ? 'Not Available' : businessDetails?.businessEmail}`}</p>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Country</p>
                            <p className='text-base mobile:text-sm'>{`${country === null || country === undefined ? 'Not Available' : country}`}</p>
                        </span>
                    </div>

                    <div className='flex flex-col gap-1'>
                        <PageTitle
                            pageTitle='Payment Channels'
                            pageTitleStyle='!mb-0 !mt-0 !truncate !text-base'
                        />
                        <div className='flex flex-col gap-5'>
                            {progressBar}
                        </div>
                    </div>

                    <div className='flex flex-col'>
                        <PageTitle
                            pageTitle='Fees'
                            pageTitleStyle='!mb-0 !mt-0 !truncate !text-base'
                            subTitle='Default fees are local fees'
                            subTitleStyle='!text-[10px]'
                        />

                        <div className='flex flex-col gap-3'>
                            {/* <div className='flex gap-1'>
                                {setFeeRuleData.map((item, i) => (
                                    <span className={`border p-2 w-full cursor-pointer rounded-md ${item.label === selectedCommission && 'bg-slate-200'}`}
                                        onClick={()=>{
                                            setSelectedCommission(item.value)
                                        }}
                                    >
                                        {item.label}
                                    </span>
                                ))}
                            </div> */}

                            <RadioInput
                                label={'Select target'}
                                labelStyle={'font-semibold text-sm leading-6 text-SecondaryAccent'}
                                inputData={setFeeRuleData}
                                name={'set_fee_local'}
                                containerStyle={'!gap-8 mobile:gap-1'}
                                checkStyle={'cursor-pointer'}
                                validationErr={''}
                                setSelected={setSelectedCommission}
                            />
                            <div className='flex flex-col gap-1'>
                                <span className='font-semibold text-sm leading-6 !text-SecondaryAccent'>Rates</span>
                                <div className='flex flex-col gap-3'>
                                    {commissionData.map((item, i) => {
                                        if (selectedCommission === 'local') {
                                            return <span key={i} className='flex items-center justify-between gap-4 font-normal'>
                                                <p className='text-xs text-SecondaryAccent'>{item.channel}</p>
                                                <p className='text-sm text-DarkBg3'>{`${item.commissionPercentage}% Capped at ${item.cappedAmount}`}</p>
                                            </span>
                                        } else {
                                            return <span key={i} className='flex items-center justify-between gap-4 font-normal'>
                                                <p className='text-xs text-SecondaryAccent'>{item.channel}</p>
                                                <p className='text-sm text-DarkBg3'>{`${item.internationalPaymentOptionFee}% Capped at ${item.cappedAmount}`}</p>
                                            </span>
                                        }
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal &&
                <ViewTransaction
                    toggleModal={() => setShowModal(prevState => !prevState)}
                    data={transactionDetails}
                />
            }
            {modalState &&
                <SetCommission
                    toggleModal={() => setModalState(prevState => !prevState)}
                    setRefresh={setRefresh}
                    businessId={businessID.id}
                    businessDetails={businessDetails}
                />
            }
        </div>
    )
}

const mapStateToProps = state => ({
    businessData: state.app.businessData,
    bearerToken: state.auth.user_authData.token.token
})

export default connect(mapStateToProps, null)(BusinessDetails);